import { createSlice } from "@reduxjs/toolkit";

export const themeSlice = createSlice({
  name: "theme",
  initialState: {
    data: [],
    error: {},
    message: "",
  },
  reducers: {
    onthemePost: (state,{payload}) => {
      return {
        ...state,
        data: payload,
        message: "",
      };
    },
    onGetThemeData: (state) => {
      return {
        ...state,
        getThemeData: [],
      };
    },
    onGetThemeDataSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        getThemeData: data,
        message,
        status_code,
      };
    },
    onGetThemeDataError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        getThemeData: data,
        message,
        status_code,
      };
    },
    OnGetThemeDataReset: (state) => {
      return {
        ...state,
        getThemeData: [],
        message: "",
        status_code: null,
      };
    },
  }
});
export const { onthemePost, onGetThemeData,onGetThemeDataSuccess,onGetThemeDataError,OnGetThemeDataReset } =
themeSlice.actions;

export default themeSlice.reducer;
